export enum AnnoSubjectEnum {
  DIAM_RULER_L14 = 'DiamRulerL14',
  GBMROI = 'GBMROI',
  primaryLocationArea = 'primaryLocationArea'
}
